import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@components/Modal';
import { TermsAndConditions } from '@components/TermsAndConditions';
import './TermsModal.css';

export interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept?: () => void;
  onDecline?: () => void;
  title?: string;
  acceptText?: string;
  declineText?: string;
}

export function TermsModal({
  isOpen,
  onClose,
  onAccept,
  onDecline,
  title,
  acceptText,
  declineText,
}: TermsModalProps) {
  const { t, i18n } = useTranslation();
  const isNotEnglish = i18n.language !== 'en';

  const handleAccept = () => {
    onAccept?.();
    onClose();
  };

  const handleDecline = () => {
    onDecline?.();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel={title || t('subscription.termsTitle', 'Terms of Service')}
    >
      <div className="auth-terms-modal-header">
        <h2 className="auth-terms-modal-title">
          {title || t('subscription.termsTitle', 'Terms of Service')}
        </h2>
        <button
          type="button"
          className="auth-terms-modal-close"
          onClick={onClose}
          aria-label={t('common.close', 'Close')}
        >
          ×
        </button>
      </div>
      <div className="auth-terms-modal-body">
        {isNotEnglish && (
          <p style={{ fontStyle: 'italic', fontSize: '0.9rem', marginTop: '0', marginBottom: '1rem' }}>
            {t('terms.disclaimer')}
          </p>
        )}
        <TermsAndConditions />
      </div>
      <div className="auth-terms-modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleDecline}
        >
          {declineText || t('common.decline', 'Decline')}
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleAccept}
        >
          {acceptText || t('common.accept', 'Accept')}
        </button>
      </div>
    </Modal>
  );
}
